export const SET_PHONE = 'SET_PHONE';
export const SET_PHONE_DONE = 'SET_PHONE_DONE';
export const SET_PHONE_ERROR = 'SET_PHONE_ERROR';
export const SET_PHONE_RESET = 'SET_PHONE_RESET';
export const VERIFY_PHONE = 'VERIFY_PHONE';
export const VERIFY_PHONE_DONE = 'VERIFY_PHONE_DONE';
export const VERIFY_PHONE_ERROR = 'VERIFY_PHONE_ERROR';
//# sourceMappingURL=actionTypes.js.map